

let WHITELABELING = {

    tenantId: 0,
    shortName: "",
    longName: "",
    showHeader: true,
    logo : "",
    images: {
        passwordCheckmark: "https://cdn.regopayments.com/tenants/Mazoola/web/public/assets/images/RegexCheckbox.svg",
    }
}


export default WHITELABELING;